<syslink-wysiwyg
    name="Note"
    [(model)]="element.InternalNote"
    [table]="false"
    [multilineToolbar]="true"
    height="200"
>
</syslink-wysiwyg>
